(function ($) {
  'use strict';

  function initializePriceSlider() {
    var slider = $('#slider-range');
    if (!slider.length || !$.fn.slider) return;

    var urlParameters = new URLSearchParams(window.location.search);
    var maximumPrice = Number(urlParameters.get('filter.v.price.lte')) || 500;
    var minimumPrice = Number(urlParameters.get('filter.v.price.gte')) || 1;

    $('#minamount').val(minimumPrice);
    $('#maxamount').val(maximumPrice);

    if (slider.hasClass('ui-slider')) slider.slider('destroy');

    slider.slider({
      range: true,
      min: 1,
      max: 500,
      values: [minimumPrice, maximumPrice],
      slide: function (_event, ui) {
        $('#amount').val('$' + ui.values[0] + ' - $' + ui.values[1]);
        $('#minamount').val(ui.values[0]);
        $('#maxamount').val(ui.values[1]);
      }
    });

    $('#amount').val('$' + slider.slider('values', 0) + ' - $' + slider.slider('values', 1));

    slider.off('slidestop.chicsew').on('slidestop.chicsew', function (event) {
      event.preventDefault();
      var nextParameters = new URLSearchParams(window.location.search);
      nextParameters.set('filter.v.price.gte', $('#minamount').val());
      nextParameters.set('filter.v.price.lte', $('#maxamount').val());
      window.location.assign(window.location.href.split('?')[0] + '?' + nextParameters.toString());
    });
  }

  document.addEventListener('DOMContentLoaded', initializePriceSlider);
  document.addEventListener('reload-collection', initializePriceSlider);
})(window.jQuery);

/* Mobile quick filters share one in-flow panel area below a scrollable chip row.
 * Keep the original inputs inside their widgets so the theme's AJAX filtering
 * and the separate Filter By drawer continue using the same event handlers. */
(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 991px)');
  var nextPanelId = 0;

  function initializeQuickFilters() {
    document.querySelectorAll('.template-collection .toolbar.aa .col-sidebar').forEach(function (root) {
      if (root.dataset.quickFiltersInitialized) return;
      root.dataset.quickFiltersInitialized = 'true';
      var entries = [];
      var navigation = document.createElement('div');
      navigation.className = 'cs-mobile-filter-nav';
      navigation.setAttribute('role', 'group');
      navigation.setAttribute('aria-label', 'Filter products');

      function setOpen(entry, open) {
        entry.header.classList.toggle('open', open);
        entry.panel.style.display = open ? 'block' : 'none';
        entry.button.setAttribute('aria-expanded', String(open));
      }

      function synchronize() {
        if (!mobile.matches) return;
        var block = root.querySelector('.sidebar-block');
        if (!block) return;
        var widgets = Array.from(block.children).filter(function (widget) {
          return widget.classList.contains('sidebar-tag') && widget.querySelector('.widget-header') && widget.querySelector('.widget-content');
        });
        // AJAX replaces sidebar-block. Rebuild only for new nodes, not our own
        // class changes, and never duplicate or clone the checkbox inputs.
        if (widgets.length !== entries.length || widgets.some(function (widget, index) { return entries[index].widget !== widget; })) {
          navigation.replaceChildren();
          entries = widgets.map(function (widget) {
            var header = widget.querySelector('.widget-header');
            var panel = widget.querySelector('.widget-content');
            var title = header.querySelector('.sidebar-title');
            var count = header.querySelector('.filter-count-css');
            var button = document.createElement('button');
            var id = 'cs-mobile-filter-' + (++nextPanelId);
            button.type = 'button';
            button.className = 'cs-mobile-filter-chip';
            // Respect the active language instead of concatenating both labels.
            var translated = title && title.querySelector(document.body.classList.contains('lang2') ? '.lang2' : '.lang1');
            button.textContent = (translated || title || header).textContent.trim() + (count ? ' ' + count.textContent.trim() : '');
            button.id = id + '-trigger';
            button.setAttribute('aria-controls', id);
            var entry = { widget: widget, header: header, panel: panel, button: button,
              display: panel.style.display, wasOpen: header.classList.contains('open') };
            panel.id = id;
            panel.setAttribute('aria-labelledby', button.id);
            setOpen(entry, false);
            button.addEventListener('click', function () {
              var shouldOpen = button.getAttribute('aria-expanded') !== 'true';
              entries.forEach(function (other) { setOpen(other, shouldOpen && other === entry); });
            });
            navigation.appendChild(button);
            return entry;
          });
          // The existing chip row places the first (Price) widget last.
          if (entries.length > 1) navigation.appendChild(entries[0].button);
          block.before(navigation);
        }
        entries.forEach(function (entry) {
          entry.button.setAttribute('aria-expanded', String(entry.panel.style.display !== 'none' && entry.header.classList.contains('open')));
        });
        root.classList.add('cs-mobile-filters-ready');
      }

      navigation.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') entries.forEach(function (entry) { setOpen(entry, false); });
      });
      mobile.addEventListener('change', function () {
        if (mobile.matches) {
          entries.forEach(function (entry) { setOpen(entry, false); });
          synchronize();
        } else {
          root.classList.remove('cs-mobile-filters-ready');
          entries.forEach(function (entry) {
            entry.panel.style.display = entry.display;
            entry.header.classList.toggle('open', entry.wasOpen);
          });
        }
      });
      new MutationObserver(synchronize).observe(root, { childList: true, subtree: true });
      synchronize();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeQuickFilters);
  else initializeQuickFilters();
})();
